import { render, staticRenderFns } from "./RulesScope.vue?vue&type=template&id=e2a6a11e&scoped=true"
import script from "./RulesScope.vue?vue&type=script&lang=ts"
export * from "./RulesScope.vue?vue&type=script&lang=ts"
import style0 from "./RulesScope.vue?vue&type=style&index=0&id=e2a6a11e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2a6a11e",
  null
  
)

export default component.exports